import { render, staticRenderFns } from "./TextEditPopup.vue?vue&type=template&id=c86cb9dc&scoped=true"
import script from "./TextEditPopup.vue?vue&type=script&lang=js"
export * from "./TextEditPopup.vue?vue&type=script&lang=js"
import style0 from "./TextEditPopup.vue?vue&type=style&index=0&id=c86cb9dc&prod&lang=scss&scoped=true"
import style1 from "./TextEditPopup.vue?vue&type=style&index=1&id=c86cb9dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86cb9dc",
  null
  
)

export default component.exports